var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "svg2",
    viewBox: "0 0 32 32",
    width: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 32,
    width: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "speaker_x5F_louder"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "16,4 16,28 10,22 2,22 2,10 10,10  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.313,4.687l-1.446,1.447c2.515,2.531,4.07,6.017,4.07,9.867c0,3.851-1.556,7.336-4.07,9.867l1.446,1.446   C28.209,24.418,30,20.418,30,16S28.209,7.582,25.313,4.687z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.515,7.547l-1.414,1.415C22.892,10.77,24,13.255,24,16s-1.108,5.23-2.899,7.038l1.414,1.414   C24.668,22.283,26,19.298,26,16S24.668,9.717,22.515,7.547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.687,10.376l-1.414,1.415C19.34,12.873,20,14.359,20,16s-0.66,3.126-1.728,4.21l1.414,1.414   C21.116,20.179,22,18.193,22,16S21.116,11.82,19.687,10.376z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.73b7042d.svg";
export { ForwardRef as ReactComponent };